// NotFoundPage.tsx
import { Title1, Text, Button, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    height: "100%",
    // Use the non-deprecated 4-value padding overload: [top, right, bottom, left]
    ...shorthands.padding(
      tokens.spacingVerticalXXL,
      tokens.spacingHorizontalXL,
      tokens.spacingVerticalXXL,
      tokens.spacingHorizontalXL,
    ),
    boxSizing: "border-box",
  },
  title: {
    marginBottom: tokens.spacingVerticalS,
  },
  message: {
    marginBottom: tokens.spacingVerticalL,
  },
});

const NotFoundPage = () => {
  const styles = useStyles();
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <Title1 className={styles.title}>Page not found</Title1>
      <Text className={styles.message}>
        The page you are looking for could not be found.
      </Text>
      <Button appearance="primary" onClick={() => navigate("/")}>
        Go to Dashboards
      </Button>
    </div>
  );
};

export default NotFoundPage;
